import React from 'react'
import { FontAwesome } from 'react-web-vector-icons'

export function SampleNextArrow(props) {
  const { style, onClick } = props;
  return (
    <div
      className="arrowEmployee"
      style={{ ...style, display: "flex", background: "transparent", margintLeft: "2vw", cursor: "pointer"}}
      onClick={onClick}
    >
      <FontAwesome
        name='chevron-right'
        color='#222'
        size={30}
      />
    </div>
  );
}

export function SamplePrevArrow(props) {
  const { style, onClick } = props;
  return (
    <div
      className="arrowEmployee"
      style={{ ...style, display: "flex", background: "transparent", margintRight: "2vw", cursor: "pointer"}}
      onClick={onClick}
    >
      <FontAwesome
        name='chevron-left'
        color='#222'
        size={30}
      />
    </div>
  );
}